import { CREATE_CONVERSATION } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function createConversation(state: State, action: Action): State {
	if (action.type !== CREATE_CONVERSATION) {
		return state
	}

	if (action.messages) {
		return {
			...state,
			showEmptyChat: false,
			typeOfView: 'chat',
			conversationId: action.conversationId,
			conversationList: [
				{
					title: action.title,
					id: action.conversationId,
					updatedAt: action.updatedAt,
				},
				...state.conversationList,
			],
			messages: action.messages.interaction as any,
		}
	}

	if (action.message) {
		return {
			...state,
			typeOfView: 'chat',
			showEmptyChat: false,
			conversationId: action.conversationId,
			conversationList: [
				{
					title: action.title,
					id: action.conversationId,
					updatedAt: action.updatedAt,
				},
				...state.conversationList,
			],
			messages: [
				{
					role: 'user',
					content: action.message,
					id: action.messageId,
				},
			],
		}
	}

	return {
		...state,
	}
}
